import PerconaNewVersion from './PerconaNewVersion';

export default PerconaNewVersion;
